<template>
  <div class="Readily">
    <div class="content">
      <component
        :is="path"
        ref="editOrCreate"
        style="background: #fff;"
        :form-type="formType"
        :method-path="methodPath"
        @reFresh="reFresh"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkTel = (rule, value, callback) => { // 编辑验证
      const re = /^1[3456789]{1}\d{9}$/
      if (!re.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      }
      callback()
    }
    var options = [{ name: '一般', id: '一般' }, { name: '困难', id: '困难' }, { name: '特困', id: '特困' }]
    return {
      methodPath: { // 接口必传
        create: 'personal/DifficultyPeopleCreateDiff' // 创建接口
      },
      path: () => import('@/components/tableComponent/editOrCreate.vue'), // 编辑页面,如需要自定义可以引用自己的文件
      formType: {
        name: {
          label: '姓名',
          message: '请输姓名'
        },
        tel: { label: '联系电话', validator: checkTel },
        idCardNo: { label: '身份证号', message: '请输入身份证号' },
        address: { label: '家庭地址', message: '请输入家庭地址' },
        lv: { label: '困难程度', type: 'select', options, message: '请选择困难程度' }, // 下拉选择
        remark: { // 富文本
          label: '详细内容',
          type: 'rich'
        }

      }
    }
  },

  mounted() {

  },
  created() {
  },

  methods: {
    reFresh() {
      this.$go('/mine/DifficultyPeople')
    }
  }
}
</script>

<style lang="scss" scoped>
    .Readily{
    background: #f5f9fa;
    flex: 1;
    .content{
      display: flex;
      flex-direction: column;
      background: #fff;
    }
  }
</style>
